import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { FaSpinner } from 'react-icons/fa';

const ProtectedRoute = () => {
    const { user, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        // Show a loading spinner or component while checking session
        return (
            <div className="min-h-screen bg-black flex items-center justify-center">
                <FaSpinner className="animate-spin text-silver-light text-4xl" />
            </div>
        );
    }

    if (!user) {
        // User not logged in, redirect to developer page
        // Pass the current location in state so we can redirect back after login
        return <Navigate to="/developer" state={{ from: location }} replace />;
    }

    // User is logged in, render the nested routes/component
    return <Outlet />;
};

export default ProtectedRoute; 